import type { AnalyticalTableDetail } from '../../lib/analyticalTablesApi';

/** One field of an analytical-table row form, rendered per data_type — a
 * reference field (see AnalyticalTableField.reference_layer_code) shows a
 * dropdown of that layer's objects instead of a plain text input. Shared by
 * ReportsPage's "Добавить запись" and the object card's "Связанные записи"
 * (see RelatedRowsSection). */
export function AnalyticalRowFieldInput({
  field,
  value,
  onChange,
  referenceOptions,
}: {
  field: AnalyticalTableDetail['fields'][number];
  value: string;
  onChange: (v: string) => void;
  referenceOptions: { id: string; title: string }[];
}) {
  if (field.reference_layer_code) {
    return (
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 rounded-md border border-border-default bg-bg-surface px-2 text-[12px] text-text-primary outline-none"
      >
        <option value="">— выберите объект —</option>
        {referenceOptions.map((o) => (
          <option key={o.id} value={o.id}>
            {o.title}
          </option>
        ))}
      </select>
    );
  }
  if (field.data_type === 'date' || field.data_type === 'datetime') {
    return (
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 rounded-md border border-border-default bg-bg-surface px-2 text-[12px] text-text-primary outline-none"
      />
    );
  }
  if (field.data_type === 'integer' || field.data_type === 'decimal') {
    return (
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 rounded-md border border-border-default bg-bg-surface px-2 text-[12px] text-text-primary outline-none"
      />
    );
  }
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-9 rounded-md border border-border-default bg-bg-surface px-2 text-[12px] text-text-primary outline-none"
    />
  );
}
